import { Cancel, Save } from "@mui/icons-material";
import { Box, CircularProgress, Tab } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import {
  FormBenhHai,
  FormLichSuCheBien,
  FormLichSuMuaHang,
  FormPhanBon,
  FormThongTinBan,
  FormThongTinLichSu,
  FormThuocTruSau
} from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Api_DanhMuc from "../../api_danhmuc";
import { Constant } from "../../constants/constant";

const RoutesThongTinLichSuCheBien = [
  {
    path: "",
    main: () => <ThongTinLichSuCheBien />
  },
  {
    path: "add",
    main: () => <HandleThongTinLichSuCheBien />
  },
  {
    path: "edit/:id",
    main: () => <HandleThongTinLichSuCheBien />
  },
  {
    path: "detail/:id",
    main: () => <HandleThongTinLichSuCheBien view={true} />
  }
];
export default RoutesThongTinLichSuCheBien;

function ThongTinLichSuCheBien() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();
  const trangThaiThongTinList = Constant?.TrangThaiThongTin;

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListThongTinLichSuCheBien({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      {
        headerName: "Tên gọi",
        field: "tenThongTinCheBien",
        width: "400px"
      },
      {
        headerName: "Trạng thái",
        field: "trangThaiThongTin",
        width: "400px",
        cellRendererFramework: (params) => {
          let dataReturn = null
          if (params?.data?.trangThaiThongTin) {
            dataReturn = trangThaiThongTinList?.find(item => item?.id === params.data.trangThaiThongTin)?.ten
          }
          return dataReturn
        }
      },
      {
        headerName: "Ghi chú",
        field: "ghiChu",
        minWidth: 200,
        flex: 1,
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleEdit={profile?.cap !== 0 && handleEdit}
            handleDelete={profile?.cap !== 0 && handleDelete}
            handleDetail={handleDetail}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteThongTinLichSuCheBienById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        } else {
          ThongBao({ status: "error", message: res?.message || "Đã có lỗi xảy ra" });
        }      
      })
      .catch(err => {});
  };
  const handleDetail = (data) => {
    if (!data?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
      return;
    }
    navigate(`detail/${data?.id || undefined}`);
  }

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Vận hành" }, { name: "Lịch sử thông tin chế biến" }]}
      />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
        cannotCreate={profile?.cap === 0}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleThongTinLichSuCheBien({ view }) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [page, setPage] = useState("thongTinLichSu");
  const handleChangePage = (event, value) => {
    if (value === "back") {
      navigate("/thongtinlichsuchebien");
      return;
    }
    setPage(value);
  };
  const trangThaiThongTinList = Constant?.TrangThaiThongTin;
  const trangThaiMuaList = Constant?.TrangThaiMua;
  const [coSoSanXuatList, setCoSoSanXuatList] = useState(null);
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetThongTinLichSuCheBienById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(coSoSanXuatList)) {
      new Api().GetListCoSoSanXuat().then(data => {
        if (data.code === 200) {
          setCoSoSanXuatList(data?.data?.records);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    trangThaiThongTinList,
    trangThaiMuaList,
    coSoSanXuatList
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertThongTinLichSuCheBien({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          ThongBao({ status: "error", message: res?.message || "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Lịch sử thông tin chế biến", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={page}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChangePage}
                aria-label="lab API tabs example"
              >
                <Tab
                  label="Thông tin lịch sử"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="thongTinLichSu"
                />
                <Tab
                  label="Lịch sử chế biến"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="lichSuCheBien"
                />
                <Tab
                  label="Lịch sử mua hàng"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="lichSuMuaHang"
                />

                <Tab
                  label="Trở lại"
                  sx={{
                    textTransform: "none",
                    color: "#40A7DE",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                    textDecoration: "underline",
                    textUnderlineOffset: 4
                  }}
                  value="back"
                />
              </TabList>
            </Box>
            <Formik
              innerRef={f => (formRef.current = f)}
              initialValues={initialState}
              enableReinitialize={true}
              validateOnBlur={false}
              validateOnChange={false}
              validationSchema={ValidateSchema}
            >
              {({ values, errors, handleSubmit, setFieldValue }) => (
                <form onSubmit={handleSubmit}>
                  {/* div just for use scroll when error validate */}
                  <div ref={refI}></div>
                  <TabPanel
                    value="thongTinLichSu"
                    sx={{ height: "fit-content" }}
                  >
                    <FormThongTinLichSu
                      view={view}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      trangThaiThongTinList={trangThaiThongTinList}
                    />
                  </TabPanel>
                  <TabPanel value="lichSuCheBien" sx={{ height: "fit-content" }}>
                    <FormLichSuCheBien
                      view={view}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  </TabPanel>
                  <TabPanel value="lichSuMuaHang" sx={{ height: "fit-content" }}>
                    <FormLichSuMuaHang
                      view={view}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      trangThaiMuaList={trangThaiMuaList}
                      coSoSanXuatList={coSoSanXuatList}
                    />
                  </TabPanel>
                </form>
              )}
            </Formik>
          </TabContext>
        </Box>
      </div>
      <div
        style={{
          display: "flex",
          position: "fixed",
          bottom: 20,
          right: 20
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        { !view && (
          <MyButton
            onClick={() => {
              handleSave();
            }}
            txt="Lưu thông tin"
            style={{ width: 130, height: 33, marginTop: 5 }}
            icon={<Save />}
          />
        )}
      </div>
    </>
  );
}
